import { render, staticRenderFns } from "./DoneText.vue?vue&type=template&id=29dfeb7a&"
import script from "./DoneText.vue?vue&type=script&lang=js&"
export * from "./DoneText.vue?vue&type=script&lang=js&"
import style0 from "./DoneText.vue?vue&type=style&index=0&id=29dfeb7a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports